import React from 'react'
import PropTypes from 'prop-types'
import { Input } from './styles'

const Checkbox = ({
  name, onChange, defaultChecked, required
}) => (
  <Input
    name={name}
    onChange={onChange}
    defaultChecked={defaultChecked}
    required={required}
    type="checkbox"
  />
)

export default Checkbox

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  defaultChecked: PropTypes.bool,
  required: PropTypes.bool
}

Checkbox.defaultProps = {
  defaultChecked: false,
  required: false
}